import React from 'react'
import PropTypes from 'prop-types'

const BulletIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    viewBox="0 0 15 15"
    width="15"
  >
    <circle cx="7.5" cy="7.5" fill="currentColor" r="7.5" />
  </svg>
)

BulletIcon.propTypes = {
  className: PropTypes.string,
}

export default BulletIcon
